/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const TrialsResponse = zod
	.array(
		zod
			.object({
				case_id: zod.uuid().describe('Associated case ID'),
				confidence: zod.number().nullable().describe('Confidence score for the trial'),
				content_decision: zod.enum(['allow', 'review', 'block']),
				description: zod.string().describe('Description\/reason for the trial'),
				id: zod.uuid().describe('Trial ID'),
				inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
				organization_id: zod.uuid().describe('Organization ID'),
				praetor_version_id: zod.uuid().describe('Pinned praetor version used for this trial'),
				reasoning_trace: zod
					.union([
						zod.null(),
						zod
							.object({
								meta: zod
									.union([
										zod.null(),
										zod
											.object({
												iteration_count: zod.number().nullable().describe('Number of iterations'),
												termination_reason: zod
													.string()
													.nullable()
													.describe('Why the agent terminated'),
												total_tool_calls: zod.number().nullable().describe('Total tool calls made')
											})
											.describe('Summary metadata for a reasoning trace')
									])
									.optional(),
								steps: zod
									.array(
										zod.union([
											zod
												.object({
													args_digest: zod
														.looseObject({})
														.nullable()
														.describe('Truncated tool arguments'),
													duration_ms: zod.number().describe('Duration in milliseconds'),
													finished_at: zod.iso
														.datetime({ offset: true })
														.describe('Step finish timestamp'),
													index: zod.number().describe('Step index within the trace'),
													kind: zod.enum(['tool_call']),
													outcome: zod.enum(['ok', 'validation_error', 'error']),
													rationale: zod
														.string()
														.nullable()
														.describe('Agent rationale for this step'),
													result_digest: zod.string().nullable().describe('Truncated tool result'),
													started_at: zod.iso
														.datetime({ offset: true })
														.describe('Step start timestamp'),
													tool: zod.string().describe('Tool name'),
													tool_version: zod.string().nullable().describe('Tool version')
												})
												.describe('A tool invocation in the reasoning trace'),
											zod
												.object({
													duration_ms: zod.number().describe('Duration in milliseconds'),
													finished_at: zod.iso
														.datetime({ offset: true })
														.describe('Step finish timestamp'),
													index: zod.number().describe('Step index within the trace'),
													kind: zod.enum(['llm_turn']),
													rationale: zod
														.string()
														.nullable()
														.describe('Agent rationale for this step'),
													started_at: zod.iso
														.datetime({ offset: true })
														.describe('Step start timestamp')
												})
												.describe('An LLM turn in the reasoning trace'),
											zod
												.object({
													confidence: zod.number().describe('Final confidence score'),
													content_decision: zod.enum(['allow', 'review', 'block']),
													index: zod.number().describe('Step index within the trace'),
													kind: zod.enum(['final_judgement']),
													rationale: zod
														.string()
														.nullable()
														.describe('Agent rationale for this step')
												})
												.describe('The final judgement in the reasoning trace')
										])
									)
									.describe('Ordered reasoning steps')
							})
							.describe('Ordered reasoning steps and summary meta')
					])
					.optional(),
				sentence: zod
					.union([
						zod.null(),
						zod
							.object({
								actor_id: zod.string().describe('Actor ID'),
								case_id: zod.string().nullable().describe('Case ID'),
								completed_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe("When the sentence's last directive went terminal"),
								decided_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When the sentence was accepted or rejected'),
								decided_by_id: zod
									.string()
									.nullable()
									.describe('ID of the decider (user ID if type is user)'),
								decided_by_type: zod.enum(['system', 'user']),
								directives: zod
									.array(
										zod
											.object({
												case_item_id: zod.string().nullable().describe('Case item ID'),
												directive_id: zod.string().describe('Directive catalog ID'),
												duration_seconds: zod.number().nullable().describe('Duration in seconds'),
												ends_at: zod.iso
													.datetime({ offset: true })
													.nullable()
													.describe('When this directive expires'),
												id: zod.string().describe('Directive ID'),
												inserted_at: zod.iso
													.datetime({ offset: true })
													.describe('Creation timestamp'),
												lifecycle_status: zod.enum([
													'pending',
													'active',
													'served',
													'revoked',
													'voided'
												]),
												policy_plan_component_id: zod
													.string()
													.nullable()
													.describe('Directive component ID'),
												policy_plan_id: zod.string().nullable().describe('Policy plan ID'),
												reasoning: zod
													.string()
													.nullable()
													.describe('AI reasoning for this directive'),
												require_approval: zod
													.boolean()
													.describe('Whether this directive required approval'),
												revoked_at: zod.iso
													.datetime({ offset: true })
													.nullable()
													.describe('When this directive was revoked'),
												served_at: zod.iso
													.datetime({ offset: true })
													.nullable()
													.describe('When this directive was served'),
												starts_at: zod.iso
													.datetime({ offset: true })
													.nullable()
													.describe('When this directive was activated'),
												updated_at: zod.iso
													.datetime({ offset: true })
													.describe('Last update timestamp'),
												violation_id: zod.string().describe('Violation ID'),
												voided_at: zod.iso
													.datetime({ offset: true })
													.nullable()
													.describe('When this directive was voided')
											})
											.describe('An individual issued directive within a sentence')
									)
									.describe('Individual issued directives within this sentence'),
								environment_id: zod.string().describe('Environment ID'),
								finalized_at: zod.iso
									.datetime({ offset: true })
									.nullable()
									.describe('When the sentence was finalized'),
								id: zod.string().describe('Sentence ID'),
								inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
								organization_id: zod.string().describe('Organization ID'),
								proposed_by_id: zod
									.string()
									.nullable()
									.describe('ID of the proposer (user ID if type is user)'),
								proposed_by_type: zod.enum(['system', 'user']),
								reason: zod.string().nullable().describe('Overall reason for the sentence'),
								status: zod.enum(['proposed', 'accepted', 'rejected', 'completed']),
								trial_confidence: zod
									.number()
									.nullable()
									.describe('Confidence score from the associated trial'),
								trial_id: zod.string().describe('Trial ID'),
								updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp')
							})
							.describe('A per-trial decision envelope containing multiple directives')
					])
					.optional(),
				updated_at: zod.iso.datetime({ offset: true }).describe('Last update timestamp'),
				violation: zod.boolean().describe('Whether the content violates policies')
			})
			.describe('A trial for a moderation case')
	)
	.describe('List of trials');

export type TrialsResponse = zod.input<typeof TrialsResponse>;
export type TrialsResponseOutput = zod.output<typeof TrialsResponse>;
